var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "conflict-form" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-6 col-v-tablet-12" },
          [
            _c(
              "z-link",
              {
                attrs: {
                  href: "https://files.raspadskaya.com/files/ru/sustainability/anticorruption/soglasie.docx",
                  internal: "",
                  "icon-position": "left",
                },
              },
              [_vm._v("Ссылка на полный текст соглашения")]
            ),
            _vm._v(" "),
            _c(
              "z-checkbox",
              {
                ref: "agreement",
                staticClass: "u-top-margin--m",
                attrs: {
                  name: "agreement",
                  required: "",
                  checked: _vm.params.agreement,
                },
                on: { change: _vm.onBlockDataChange },
              },
              [
                _vm._v("\n                Согласен"),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-default-6 col-v-tablet-12" },
          [
            _c("z-select", {
              ref: "DIVIZ",
              attrs: {
                data: [
                  {
                    id: 1,
                    selected: false,
                    text: "ЦОФ «Абашевская»",
                  },
                  {
                    id: 2,
                    selected: false,
                    text: "ЦОФ «Кузнецкая»",
                  },
                  {
                    id: 3,
                    selected: false,
                    text: "Шахта «Абашевская»",
                  },
                  {
                    id: 4,
                    selected: false,
                    text: "Шахта «Алардинская»",
                  },
                  {
                    id: 5,
                    selected: false,
                    text: "Шахта «Есаульская»",
                  },
                  {
                    id: 6,
                    selected: false,
                    text: "Шахта «Осинниковская»",
                  },
                  {
                    id: 7,
                    selected: false,
                    text: "Шахта «Усковская»",
                  },
                  {
                    id: 8,
                    selected: false,
                    text: "АТП «Южкузбассуголь»",
                  },
                  {
                    id: 9,
                    selected: false,
                    text: "Кузнецкпогрузтранс",
                  },
                  {
                    id: 10,
                    selected: false,
                    text: "Южно-Кузбасское геологоразведочное управление",
                  },
                  {
                    id: 11,
                    selected: false,
                    text: "Промуглепроект",
                  },
                  {
                    id: 12,
                    selected: false,
                    text: "Осинниковский ремонтно-механический завод",
                  },
                  {
                    id: 13,
                    selected: false,
                    text: "Специализированно шахтномонтажно-наладочное управление",
                  },
                  {
                    id: 14,
                    selected: false,
                    text: "УМГШО",
                  },
                  {
                    id: 15,
                    selected: false,
                    text: "ПАО «Распадская»",
                  },
                  {
                    id: 16,
                    selected: false,
                    text: "Разрез «Распадский»",
                  },
                  {
                    id: 17,
                    selected: false,
                    text: "Монтажник Распадской",
                  },
                  {
                    id: 18,
                    selected: false,
                    text: "Ольжерасское шахтопроходческое управление",
                  },
                  {
                    id: 19,
                    selected: false,
                    text: "Распадская-Коксовая",
                  },
                  {
                    id: 20,
                    selected: false,
                    text: "Обогатительная фабрика «Распадская»",
                  },
                  {
                    id: 21,
                    selected: false,
                    text: "Томусинское погрузочно-транспортное управление",
                  },
                  {
                    id: 22,
                    selected: false,
                    text: "ООО «РУК»",
                  },
                ],
                placeholder: "Предприятие*",
                name: "DIVIZ",
                required: "",
              },
              on: { change: _vm.onSelDataChange },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-6 col-v-tablet-12" },
          [
            _c("z-input", {
              ref: "LAST_NAME",
              attrs: {
                placeholder: "Фамилия*",
                name: "LAST_NAME",
                required: "",
              },
              model: {
                value: _vm.params["LAST_NAME"],
                callback: function ($$v) {
                  _vm.$set(_vm.params, "LAST_NAME", $$v)
                },
                expression: "params['LAST_NAME']",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-default-6 col-v-tablet-12" },
          [
            _c("z-input", {
              ref: "FIRST_NAME",
              attrs: { placeholder: "Имя*", name: "FIRST_NAME", required: "" },
              model: {
                value: _vm.params["FIRST_NAME"],
                callback: function ($$v) {
                  _vm.$set(_vm.params, "FIRST_NAME", $$v)
                },
                expression: "params['FIRST_NAME']",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-6 col-v-tablet-12" },
          [
            _c("z-input", {
              ref: "MIDDLE_NAME",
              attrs: {
                placeholder: "Отчество*",
                name: "MIDDLE_NAME",
                required: "",
              },
              model: {
                value: _vm.params["MIDDLE_NAME"],
                callback: function ($$v) {
                  _vm.$set(_vm.params, "MIDDLE_NAME", $$v)
                },
                expression: "params['MIDDLE_NAME']",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-default-6 col-v-tablet-12" }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sg-section" },
        [
          _c(
            "z-caption",
            {
              staticClass: "u-top-margin--m u-bottom-margin--xs",
              attrs: { tag: "p", size: "m" },
            },
            [
              _vm._v(
                "\n            1. Отношения с компаниями - контрагентами\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-top-margin--m u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                1.1\tИмеете ли Вы или член Вашей семьи собственность или финансовые интересы в любой компании-контрагенте ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y1[1]",
                      attrs: {
                        name: "question_y1[1]",
                        required: "",
                        checked: _vm.params.question_y1[1],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n1[1]",
                      attrs: {
                        name: "question_n1[1]",
                        required: "",
                        checked: _vm.params.question_n1[1],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_1[1]",
                    attrs: {
                      name: "explanation_1[1]",
                      placeholder: "Пояснение к 1.1",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_1[1],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_1, 1, $$v)
                      },
                      expression: "params.explanation_1[1]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                1.2\tЯвляетесь ли Вы или член Вашей семьи руководителем или учредителем в любой компании-контрагенте ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y1[2]",
                      attrs: {
                        name: "question_y1[2]",
                        required: "",
                        checked: _vm.params.question_y1[2],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n1[2]",
                      attrs: {
                        name: "question_n1[2]",
                        required: "",
                        checked: _vm.params.question_n1[2],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_1[2]",
                    attrs: {
                      name: "explanation_1[2]",
                      placeholder: "Пояснение к 1.2",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_1[2],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_1, 2, $$v)
                      },
                      expression: "params.explanation_1[2]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                1.3\tЕсть ли у Вас или у члена Вашей семьи отношения найма (контракт) или консультационные отношения с какой-либо компанией-контрагентом ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y1[3]",
                      attrs: {
                        name: "question_y1[3]",
                        required: "",
                        checked: _vm.params.question_y1[3],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n1[3]",
                      attrs: {
                        name: "question_n1[3]",
                        required: "",
                        checked: _vm.params.question_n1[3],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_1[3]",
                    attrs: {
                      name: "explanation_1[3]",
                      placeholder: "Пояснение к 1.3",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_1[3],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_1, 3, $$v)
                      },
                      expression: "params.explanation_1[3]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                1.4\tПолучали ли Вы от контрагентов Компании или их представителей денежное вознаграждение за оказанные услуги, в том числе в виде оплаты Вашего кредита или долга?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y1[4]",
                      attrs: {
                        name: "question_y1[4]",
                        required: "",
                        checked: _vm.params.question_y1[4],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n1[4]",
                      attrs: {
                        name: "question_n1[4]",
                        required: "",
                        checked: _vm.params.question_n1[4],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_1[4]",
                    attrs: {
                      name: "explanation_1[4]",
                      placeholder: "Пояснение к 1.4",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_1[4],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_1, 4, $$v)
                      },
                      expression: "params.explanation_1[4]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                1.5\tПолучали ли Вы или член Вашей семьи от контрагента ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская» какие-либо подарки эквивалентной стоимостью более 100 долларов США, которые не были ранее заявлены и одобрены в соответствии с политикой Компании?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y1[5]",
                      attrs: {
                        name: "question_y1[5]",
                        required: "",
                        checked: _vm.params.question_y1[5],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n1[5]",
                      attrs: {
                        name: "question_n1[5]",
                        required: "",
                        checked: _vm.params.question_n1[5],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_1[5]",
                    attrs: {
                      name: "explanation_1[5]",
                      placeholder: "Пояснение к 1.5",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_1[5],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_1, 5, $$v)
                      },
                      expression: "params.explanation_1[5]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                1.6\tПринимали ли Вы или член Вашей семьи какие-либо приглашения в поездки или на мероприятия от компаний-контрагентов ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская» совокупной эквивалентной стоимостью более 500 долларов США, которые не были ранее согласованы комплаенс менеджером?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y1[6]",
                      attrs: {
                        name: "question_y1[6]",
                        required: "",
                        checked: _vm.params.question_y1[6],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n1[6]",
                      attrs: {
                        name: "question_n1[6]",
                        required: "",
                        checked: _vm.params.question_n1[6],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_1[6]",
                    attrs: {
                      name: "explanation_1[6]",
                      placeholder: "Пояснение к 1.6",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_1[6],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_1, 6, $$v)
                      },
                      expression: "params.explanation_1[6]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                1.7\tДарили ли Вы или член Вашей семьи подарки или приглашения на мероприятия какому-либо представителю контрагентов Компании. Вопрос касается подарков совокупной эквивалентной стоимостью более 100 долларов США, которые не были ранее согласованы комплаенс менеджером?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y1[7]",
                      attrs: {
                        name: "question_y1[7]",
                        required: "",
                        checked: _vm.params.question_y1[7],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n1[7]",
                      attrs: {
                        name: "question_n1[7]",
                        required: "",
                        checked: _vm.params.question_n1[7],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_1[7]",
                    attrs: {
                      name: "explanation_1[7]",
                      placeholder: "Пояснение к 1.7",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_1[7],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_1, 7, $$v)
                      },
                      expression: "params.explanation_1[7]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                1.8\tДавали ли в долг Вы или член Вашей семьи любую сумму денег владельцам или сотрудникам контрагента Компании?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y1[8]",
                      attrs: {
                        name: "question_y1[8]",
                        required: "",
                        checked: _vm.params.question_y1[8],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n1[8]",
                      attrs: {
                        name: "question_n1[8]",
                        required: "",
                        checked: _vm.params.question_n1[8],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_1[8]",
                    attrs: {
                      name: "explanation_1[8]",
                      placeholder: "Пояснение к 1.8",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_1[8],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_1, 8, $$v)
                      },
                      expression: "params.explanation_1[8]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                1.9\tПолучали ли в долг Вы или член Вашей семьи любую сумму денег от владельцев или сотрудников контрагентов Компании?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y1[9]",
                      attrs: {
                        name: "question_y1[9]",
                        required: "",
                        checked: _vm.params.question_y1[9],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n1[9]",
                      attrs: {
                        name: "question_n1[9]",
                        required: "",
                        checked: _vm.params.question_n1[9],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_1[9]",
                    attrs: {
                      name: "explanation_1[9]",
                      placeholder: "Пояснение к 1.9",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_1[9],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_1, 9, $$v)
                      },
                      expression: "params.explanation_1[9]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                1.10 Передавали ли Вы специальную, конфиденциальную или инсайдерскую информацию контрагентам Компании для обеспечения их преимущества перед конкурентами?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y1[10]",
                      attrs: {
                        name: "question_y1[10]",
                        required: "",
                        checked: _vm.params.question_y1[10],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n1[10]",
                      attrs: {
                        name: "question_n1[10]",
                        required: "",
                        checked: _vm.params.question_n1[10],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_1[10]",
                    attrs: {
                      name: "explanation_1[10]",
                      placeholder: "Пояснение к 1.10",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_1[10],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_1, 10, $$v)
                      },
                      expression: "params.explanation_1[10]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                1.11 Знаете ли Вы о каком-либо сотруднике Компании, который является работником, консультантом или совладельцем компаний-контрагентов ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y1[11]",
                      attrs: {
                        name: "question_y1[11]",
                        required: "",
                        checked: _vm.params.question_y1[11],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n1[11]",
                      attrs: {
                        name: "question_n1[11]",
                        required: "",
                        checked: _vm.params.question_n1[11],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_1[11]",
                    attrs: {
                      name: "explanation_1[11]",
                      placeholder: "Пояснение к 1.11",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_1[11],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_1, 11, $$v)
                      },
                      expression: "params.explanation_1[11]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sg-section" },
        [
          _c(
            "z-caption",
            {
              staticClass: "u-top-margin--m u-bottom-margin--xs",
              attrs: { tag: "p", size: "m" },
            },
            [_vm._v("\n            2. Отношения с конкурентами\n        ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                2.1 Имеете ли Вы или член Вашей семьи какую-либо собственность или финансовые интересы в компании-конкуренте ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y2[1]",
                      attrs: {
                        name: "question_y2[1]",
                        required: "",
                        checked: _vm.params.question_y2[1],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n2[1]",
                      attrs: {
                        name: "question_n2[1]",
                        required: "",
                        checked: _vm.params.question_n2[1],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_2[1]",
                    attrs: {
                      name: "explanation_2[1]",
                      placeholder: "Пояснение к 2.1",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_2[1],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_2, 1, $$v)
                      },
                      expression: "params.explanation_2[1]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                2.2 Принимали ли Вы или член Вашей семьи какие-либо займы, подарки, деньги или приглашения в поездки или на мероприятия от конкурента Компании, ранее не согласованные комплаенс менеджером?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y2[2]",
                      attrs: {
                        name: "question_y2[2]",
                        required: "",
                        checked: _vm.params.question_y2[2],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n2[2]",
                      attrs: {
                        name: "question_n2[2]",
                        required: "",
                        checked: _vm.params.question_n2[2],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_2[2]",
                    attrs: {
                      name: "explanation_2[2]",
                      placeholder: "Пояснение к 2.2",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_2[2],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_2, 2, $$v)
                      },
                      expression: "params.explanation_2[2]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                2.3 Есть ли у Вас или члена Вашей семьи отношения найма, консалтинга или контрактные отношения с каким-либо конкурентом Компании?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y2[3]",
                      attrs: {
                        name: "question_y2[3]",
                        required: "",
                        checked: _vm.params.question_y2[3],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n2[3]",
                      attrs: {
                        name: "question_n2[3]",
                        required: "",
                        checked: _vm.params.question_n2[3],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_2[3]",
                    attrs: {
                      name: "explanation_2[3]",
                      placeholder: "Пояснение к 2.3",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_2[3],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_2, 3, $$v)
                      },
                      expression: "params.explanation_2[3]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                2.4 Передавали ли Вы служебную, конфиденциальную или инсайдерскую информацию конкурентам? (За исключением той, которую Компания уполномочила Вас предоставить для поддержания деловых отношений)."
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y2[4]",
                      attrs: {
                        name: "question_y2[4]",
                        required: "",
                        checked: _vm.params.question_y2[4],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n2[4]",
                      attrs: {
                        name: "question_n2[4]",
                        required: "",
                        checked: _vm.params.question_n2[4],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_2[4]",
                    attrs: {
                      name: "explanation_2[4]",
                      placeholder: "Пояснение к 2.4",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_2[4],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_2, 4, $$v)
                      },
                      expression: "params.explanation_2[4]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sg-section" },
        [
          _c(
            "z-caption",
            {
              staticClass: "u-top-margin--m u-bottom-margin--xs",
              attrs: { tag: "p", size: "m" },
            },
            [
              _vm._v(
                "\n            3. Отношения с ООО «РУК», Управляемыми Обществами или иными предприятиями группы ПАО «Распадская»\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                3.1 Используете ли Вы ресурсы или оборудование Компании для извлечения личной материальной выгоды? Вопрос не касается технических средств (компьютер, телефон), которые Компания передала Вам в личное пользование для выполнения служебных обязанностей."
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y3[1]",
                      attrs: {
                        name: "question_y3[1]",
                        required: "",
                        checked: _vm.params.question_y3[1],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n3[1]",
                      attrs: {
                        name: "question_n3[1]",
                        required: "",
                        checked: _vm.params.question_n3[1],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_3[1]",
                    attrs: {
                      name: "explanation_3[1]",
                      placeholder: "Пояснение к 3.1",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_3[1],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_3, 1, $$v)
                      },
                      expression: "params.explanation_3[1]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                3.2 Являетесь ли Вы сотрудником другой компании, не связанной с ООО «РУК», Управляемыми Обществами или иных предприятий группы ПАО «Распадская», о чем Вы не уведомили своих руководителей (параллельная занятость)?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y3[2]",
                      attrs: {
                        name: "question_y3[2]",
                        required: "",
                        checked: _vm.params.question_y3[2],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n3[2]",
                      attrs: {
                        name: "question_n3[2]",
                        required: "",
                        checked: _vm.params.question_n3[2],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_3[2]",
                    attrs: {
                      name: "explanation_3[2]",
                      placeholder: "Пояснение к 3.2",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_3[2],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_3, 2, $$v)
                      },
                      expression: "params.explanation_3[2]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                3.3 Есть ли у Вас родственники, работающие в ООО «РУК», Управляемых Обществах или иных предприятиях группы ПАО «Распадская»? Укажите, пожалуйста, ФИО."
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y3[3]",
                      attrs: {
                        name: "question_y3[3]",
                        required: "",
                        checked: _vm.params.question_y3[3],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n3[3]",
                      attrs: {
                        name: "question_n3[3]",
                        required: "",
                        checked: _vm.params.question_n3[3],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_3[3]",
                    attrs: {
                      name: "explanation_3[3]",
                      placeholder: "Пояснение к 3.3",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_3[3],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_3, 3, $$v)
                      },
                      expression: "params.explanation_3[3]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                3.4 Принимали ли Вы когда-либо в ООО «РУК», Управляемых Обществах или иных предприятиях группы ПАО «Распадская» решения, прямо или косвенно касающиеся Вашего родственника, который также является сотрудником ООО «РУК», Управляемых Обществ или иных предприятий группы ПАО «Распадская»?"
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y3[4]",
                      attrs: {
                        name: "question_y3[4]",
                        required: "",
                        checked: _vm.params.question_y3[4],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n3[4]",
                      attrs: {
                        name: "question_n3[4]",
                        required: "",
                        checked: _vm.params.question_n3[4],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_3[4]",
                    attrs: {
                      name: "explanation_3[4]",
                      placeholder: "Пояснение к 3.4",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_3[4],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_3, 4, $$v)
                      },
                      expression: "params.explanation_3[4]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xs",
                attrs: { tag: "p", size: "s" },
              },
              [
                _vm._v(
                  "\n                3.5 Делали ли Вы копии конфиденциальных материалов, принадлежащих Компании, для передачи третьим лицам без разрешения уполномоченных лиц? Вопрос касается также и отправки конфиденциальной или служебной информации Компании на адрес личной электронной почты для пересылки третьим лицам."
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_y3[5]",
                      attrs: {
                        name: "question_y3[5]",
                        required: "",
                        checked: _vm.params.question_y3[5],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Да\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-checkbox",
                    {
                      ref: "question_n3[5]",
                      attrs: {
                        name: "question_n3[5]",
                        required: "",
                        checked: _vm.params.question_n3[5],
                      },
                      on: { change: _vm.onBlockDataChangequestion },
                    },
                    [
                      _vm._v(
                        "\n                        Нет\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-default-6 col-v-tablet-12" },
                [
                  _c("z-textarea", {
                    ref: "explanation_3[5]",
                    attrs: {
                      name: "explanation_3[5]",
                      placeholder: "Пояснение к 3.5",
                      resize: "",
                    },
                    model: {
                      value: _vm.params.explanation_3[5],
                      callback: function ($$v) {
                        _vm.$set(_vm.params.explanation_3, 5, $$v)
                      },
                      expression: "params.explanation_3[5]",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-12" },
          [
            _c(
              "z-checkbox",
              {
                ref: "agreement2",
                staticClass: "u-top-margin--m",
                attrs: {
                  name: "agreement2",
                  required: "",
                  checked: _vm.params.agreement2,
                },
                on: { change: _vm.onBlockDataChange },
              },
              [
                _vm._v(
                  "\n                Заполняя этот Опросник по раскрытию информации, я подтверждаю, что прочитал(а), понял(а) и раскрыл(а) все возможные конфликты интересов. Я подтверждаю, что в соответствии с Политикой сообщу о любом вновь возникающем конфликте интересов комплаенс менеджеру и своему руководителю."
                ),
                _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "conflict-form__buttons" },
        [
          _c("z-button", { on: { click: _vm.submit } }, [_vm._v("Отправить")]),
          _vm._v(" "),
          _c(
            "z-button",
            { attrs: { kind: "secondary" }, on: { click: _vm.reset } },
            [_vm._v("Сбросить всё")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("z-modal", { attrs: { id: "success-modal" } }, [
        _c(
          "div",
          { staticClass: "seekers-form-success" },
          [
            _c("z-icon", {
              staticClass: "u-bottom-margin--m",
              attrs: { name: "worker", width: "96", height: "96" },
            }),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                Спасибо! Ваши ответы приняты.\n            "
              ),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }